import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select ,DatePicker  } from 'antd';
import { PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,FileImageOutlined,CloseOutlined,AudioOutlined } from '@ant-design/icons';

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';

import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';

const { TextArea } = Input;
const { Panel } = Collapse;
const { RangePicker } = DatePicker;

const buttonWidth = 70;

function callback(key) {	
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

function onOk(value) {
  console.log('onOk: ', value);
}

const storedFiles=[];
const storedFilespdf=[];
const storedFilesaudio=[];
const dateFormat = 'YYYY-MM-DD';

function get_url_name(str){
	var result = /[^/]*$/.exec(str)[0];
	return result;
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			type: '1',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			tabs: '1',
			title: '',
			locatoin: '',
			start_date: '',
			end_date: '',
			program: '',
			children_id: 1,
			details: '',
			image: '',
			video: '',
			file: '',
			loading: false,
  		    iconLoading: false,
  		    all_day: 0,
  		    notify: 0,
  		    program_list: [],
			selectedFiles:null,
			previewImage: '',
			previewTitle: '',
			previewVisible: false,
			file_list: [],
			file_list_pdf: [],
			file_list_audio: [],
  		    event_list: [],
			id: this.props.match.params.id,
			school_list: [],
			school_array: [],
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onChangestart = this.onChangestart.bind(this);
		this.onChangeend = this.onChangeend.bind(this);
		this.change_program = this.change_program.bind(this);
		
		this.change_school = this.change_school.bind(this);
		this.goBack = this.goBack.bind(this);
		this.handleCheck = this.handleCheck.bind(this);
		this.handleSizeChangeAllday= this.handleSizeChangeAllday.bind(this);		
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		this.checkData();
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = storedArray['data'][0]['type'];
			var app = {user_id : user_id,id:this.props.match.params.id,school_id:school_id,type:type}
			
			getData('erp/event_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							event_list: result['data'],
							id: result['data'][0]['id'],
							school_array: result['data'][0]['school_array'],
							title:  result['data'][0]['title'],
							type:  result['data'][0]['type'],
							locatoin:  result['data'][0]['locatoin'],
							start_date:  result['data'][0]['start_date'],
							end_date:  result['data'][0]['end_date'],
							program:  result['data'][0]['program'],
							details:  result['data'][0]['details'],
							all_day:  result['data'][0]['all_day'],
							notify:  result['data'][0]['notify'],
						});
						this.change_school(result['data'][0]['school_array']);
						
					}else{
						this.setState({
							event_list: [],
							
						});
					}	
						}
					});	
			
			getData('common/school_list_by_staff',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
							
						});
					}	
						}
			});
			
	}
  }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
  handleSizeChangeAllday = e => {
	if(this.state.all_day == 0){
		this.setState({ all_day: 1 });
	}else{
		this.setState({ all_day: 0 });
	}
    
	};
  
  openQuantity(e){
	this.setState({ tabs: e });
	}  
	
	onChangestart(value, dateString) {
		this.setState({ start_date: dateString });
	}
	onChangeend(value, dateString) {
		this.setState({ end_date: dateString });
	}
	
	change_program(event){
         this.setState({program: event});
     }
	 
	 change_school(event){
		console.log('school : ',event);
        this.setState({school_array: event});
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var type = storedArray['data'][0]['type'];
		
		var app = {user_id : user_id,school_id:event,type:type}
		getData('common/class_list_by_school',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						program_list: result['data'],
					});
				}else{
					this.setState({
						program_list: [],
						
					});
				}	
					}
		});
     }
	
	handleSubmit=(e)=>{
    e.preventDefault();
	if(localStorage.getItem('schoolData')){
    this.setState({ loading: true });
    
      getData('erp/edit_event',this.state).then((result) => {
      if(result.status==400){
             message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
			const selectedFiles = this.state.file_list;
			const selectedFilespdf = this.state.file_list_pdf;
			const selectedFilesaudio = this.state.file_list_audio;
			const data = new FormData() ;
			
			const image = [] ;
			const pdf = [] ;
			const audio = [] ;
			
			if(selectedFiles.length == 0){
				data.append(`image[0]`, '[]')
			}
			if(selectedFilespdf.length == 0){
				data.append(`pdf[0]`, '[]')
			}
			if(selectedFilesaudio.length == 0){
				data.append(`audio[0]`, '[]')
			}
			
			for (let i = 0; i < selectedFiles.length; i++) {
				data.append(`image[${i}]`, selectedFiles[i].selectedFiles)
			}
			
			for (let i = 0; i < selectedFilespdf.length; i++) {
				data.append(`pdf[${i}]`, selectedFilespdf[i].storedFilespdf)
			}
			
			for (let i = 0; i < selectedFilesaudio.length; i++) {
				data.append(`audio[${i}]`, selectedFilesaudio[i].storedFilesaudio)
			}
			
			data.append('id', result.id);	     
			data.append('type', 'event');	     
			data.append('user_id', this.state.user_id)
			let url = "https://kcisapi.kidzonia.co.in/v1/erp/update_attached_file";
				axios.post(url, data, {
			})
			.then(res => {
				message.config({ top: 150});
				message.success('Event updated',2);
				this.setState({ loading: false });
                this.setState({comment_text:''});
			    window.location.reload(false);
			})
          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }	
  
  goBack(){
		window.location.href = '/calendar/index';
	}
	
		handleFileSelect = (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFiles.length > 3) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 4100000) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 4MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					//if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'image',
							selectedFiles: f
						}
						storedFiles.push(app);
						people.push(f);
					// }				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list:storedFiles});
		}, 500);
	} 

	removeFile= (file,e) =>{
		for (var i = 0; i < storedFiles.length; i++) {
			if (storedFiles[i].file_name === file) {
				storedFiles.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFiles.length=='0') {
				const file = document.querySelector('.file');
				file.value = '';
			}			
			this.setState({file_list:storedFiles});
			//console.log(storedFiles);
		}, 500);
	}
	
	handleFileSelectpdf = (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFilespdf.length > 3) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 4100000) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 4MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					//if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'pdf',
							storedFilespdf: f
						}
						storedFilespdf.push(app);
						people.push(f);
					// }				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list_pdf:storedFilespdf});
		}, 500);
	} 

	removeFilepdf = (file,e) =>{
		for (var i = 0; i < storedFilespdf.length; i++) {
			if (storedFilespdf[i].file_name === file) {
				storedFilespdf.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFilespdf.length=='0') {
				const file = document.querySelector('.file');
				file.value = '';
			}			
			this.setState({file_list_pdf:storedFilespdf});
			//console.log(storedFilespdf);
		}, 500);
	}
	
	handleFileSelectaudio = (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFilesaudio.length > 3) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 4100000) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 4MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					//if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'pdf',
							storedFilesaudio: f
						}
						storedFilesaudio.push(app);
						people.push(f);
					// }				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list_audio:storedFilesaudio});
		}, 500);
	} 

	removeFileaudio = (file,e) =>{
		for (var i = 0; i < storedFilesaudio.length; i++) {
			if (storedFilesaudio[i].file_name === file) {
				storedFilesaudio.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFilesaudio.length=='0') {
				const file = document.querySelector('.file');
				file.value = '';
			}			
			this.setState({file_list_audio:storedFilesaudio});
			//console.log(storedFilesaudio);
		}, 500);
	}

	removeServer = (file_name,file_type,id) => {
		//alert(file_name);
		
		var user_id = this.state.user_id;
		var school_id = this.state.school_id;
		let program_id = this.props.match.params.id;
		
	
		var app = {
			user_id : user_id,
			school_id : school_id,
			id:program_id,
			file_name:file_name,
			file_type:file_type,
			type:'event'
		}
			getData('erp/attachment_delete',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){						
						message.config({ top: 150});
						message.success('File deleted',2);
						this.checkData();				
				   }
				   else{
						message.config({ top: 150});
						message.error('Error while deleting File!',2);	
						this.checkData();								
				   }
				}
			});
		};
	

  handleCheck(event) {
    const target = event.target;	
    let value;	
	if(target.checked){ value = 1;}	else{ value = 0;}	
    const name = target.name;
    this.setState({
      [name]: value
    });
	//alert(this.state.is_bookset);
  }

	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img ant-upload-text">
						<Tooltip placement="right" title="Audio">
							 <label tabindex="0" class="pointer" role="button" for="audio">
								<img src={music} className="pointer"/>
								<input  onChange={this.handleFileSelectaudio} class="file-upload__input file hide" type="file" name="files" id="audio" accept="audio/*" multiple="multiple" style={{display: 'none',opacity: '0'}}/> 
							</label>
						</Tooltip>
						</p>
						<p className="center upload-img">
							<Tooltip placement="right" title="Pdf">
								<label tabindex="0" class="pointer" role="button" for="pdf">
									<img src={pdf_} className="pointer"/>
									<input  onChange={this.handleFileSelectpdf} class="file-upload__input file hide" type="file" name="files" id="pdf" accept=".pdf" multiple="multiple" style={{display: 'none',opacity: '0'}}/> 
								</label>
							</Tooltip>
						</p>
						<p className="center upload-img">
							<Tooltip placement="right" title="Image">
								<label tabindex="0" class="pointer" role="button" for="image">
									<img src={image} className="pointer"/>
									<input  onChange={this.handleFileSelect} class="file-upload__input file hide" type="file" name="files" id="image" accept="image/*" multiple="multiple" style={{display: 'none',opacity: '0'}}/> 
								</label>
							</Tooltip>
						</p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i>Edit Event
								
								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/calendar`} class="router-link-active" target="_self">Calendar</a> </li>
										<li class="breadcrumb-item"> Edit Event </li>
									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			<div id="main" class="bg-off">
         <div class="row">
		 
         
            {this.state.event_list.map((list) => (  
   			  <>
			<div class="col-md-12 ex-padd">
            <div class="">
			   <div class="col-md-12 mb-20 card-content iq-card">
			   <div class="col-md-12 center mb-10 mt-10 meal add-event ">
						 
						 <Radio.Group value={this.state.type} name="type"  onChange={this.handleSizeChange}>
						  <Radio.Button value="1">Events</Radio.Button>
						  <Radio.Button value="2">Holidays</Radio.Button>
						  <Radio.Button value="4">Celebrations</Radio.Button>
						  <Radio.Button value="5">PTM</Radio.Button>
						</Radio.Group>
				</div>
                  <section class="invoice-list-wrapper section food mt-50 ">
					 
					
					<div class="children bg-blue communication  iq-card2 flow-root">
                     
						
							
								<div>
								
									<div class="view-Profile col m12 mt-20 form-group">
									<div class="row">
										<div class="col-md-12">
										<div class="row">
										
										<div class="col-md-12 mt-10 mb-10">
											<label>Select School</label>
											<Select name="school" mode="multiple" onChange={this.change_school} value={this.state.school_array}>
												{this.state.school_list.map((list) => ( 
													<Select.Option value={list.erp_id}>{list.name}</Select.Option>
												))}
											</Select>
										</div>
										
										<div class="col-md-4">
											<label>{(() => {
											   if (this.state.type == '1' ) {
													return (<>Event </>)	
											   }else if(this.state.type == '2'){
													return (<>Holidays </>)	
											   }else if(this.state.type == '4'){
													return (<>Celebrations </>)	
											   }else if(this.state.type == '5'){
													return (<>PTM </>)	
											   }
											})()} Title</label>
											<input type="text" name="title" defaultValue={list.title}  onChange={this.handleSizeChange} />
										</div>	
										{(() => {
										   if (this.state.type == '1' ) {
												return (<>
												<div class="col-md-4">
													<label>{(() => {
													   if (this.state.type == '1' ) {
															return (<>Event </>)	
													   }else if(this.state.type == '2'){
															return (<>Holidays </>)	
													   }
													})()} Location</label>
													<input type="text"  name="locatoin" defaultValue={list.locatoin} onChange={this.handleSizeChange}/>
												</div>	
												</>)	
										   }
										})()}
										
										<div class="col-md-2 add-notice">
											<input type="checkbox"  id="1" value={this.state.all_day}  name="all_day"   checked={`${this.state.all_day==1?'checked':'a'}`}	   onChange={this.handleCheck}/>
											<label for="1" class="add-event-label">All Day</label>
										</div>
										<div class="col-md-2 add-notice">
											<input type="checkbox"  id="2" value="1" name="notify" checked={`${this.state.notify==1?'checked':'a'}`} onChange={this.handleCheck} />
											<label for="2" class="add-event-label">Notify Recipients </label>
										</div>
										</div>
										</div>
										<div class="col-md-4 mt-10">
											<label>Start Date</label>
											<DatePicker showTime onChange={this.onChangestart}   defaultValue={moment(list.start_date, dateFormat)} />
										</div>
										{(() => {  
										if (this.state.all_day =='0') {
												return (
															<div class="col-md-4 mt-10">
																<label>End Date</label>
																<DatePicker showTime onChange={this.onChangeend}  />
															</div>
														)
												}
										})()}
										{(() => {
											   if (this.state.type != '1' && this.state.type != '2') {
													return (<>
										<div class="col-md-12 mt-10 mb-10">
											<label>Select Program</label>
											<Select name="program"  mode="multiple" value={this.state.program} onChange={this.change_program}>
											
												{this.state.program_list.map((list) => ( 
													<Select.Option value={list.erp_id}>{list.name}</Select.Option>
												))}
											</Select>
										</div>	
										</>)	
											   }
											})()}
										
										<div class="col-md-12 mt-10">
										<div class="meal mt-20 mb-20 pb-20">
											<div class="row">
											<div class="col-md-10">
											 <TextArea
											  placeholder="Enter Details Here !!"
											  autoSize={{ minRows: 2, maxRows: 6 }}
											  onChange={this.handleSizeChange} 
											  name="details"
											  id="details"
											  defaultValue={list.details}
											/>
											</div>
											<div class="col-md-2 desktop-view">
											<Popover content={content} trigger="click">
											  <img src={attached} class="" alt="image" />
											</Popover>
											</div>
											
											</div>
										</div>
										</div>
										
									</div>
									</div>
									
									
									
									
								</div>
									
									
					<div class="view-Profile col m12 mb-20 w-100">
					<div class="mb-20 pb-20 bb photos d-flow-root">
						<div class="upload-gallery " id="img_view">
											<div class="col-md-12">
											
											
							{(() => {
							if (list.attach==1) {
							return (
							 <>
							  {(() => {
								if (list.audio.length>0) {
									return (													
									   <div class="col m12  s12 no-padd m-audio">
											{list.audio.map((audio) => (<>	
										
														 
											<div class="dfs">
											<div class="ant-upload-list ant-upload-list-picture-card">
											<div class="ant-upload-list-item w-100 ant-upload-list-item-done">
											   <div class="ant-upload-list-item-info">					  
										         <audio width="350" height="250" controls >
													<source src={audio} type="audio/mpeg"/>
												 </audio>	
												
												  <button class="remove" id='remove' onClick={this.removeServer.bind(this,get_url_name(audio),'video',list.id)} type='button' title='Remove'><i class="ri-close-line icon-x"></i></button>									

											</div>
											</div>
											</div>
											</div>					
	 
														 
														 
													</>))}
												</div>	
												)
											}
										})()}		

										{(() => {
											if (list.file.length>0) {
												return (
											<div class="col m12  s12 no-padd  m-pdf">
												{list.file.map((file) => (<>
											
										<div class="dfs">
											<div class="ant-upload-list ant-upload-list-picture-card">
											<div class="ant-upload-list-item w-100 ant-upload-list-item-done">
											   <div class="ant-upload-list-item-info">					  
												<a href={file} class="daily-link"  target="_blank">
												<Button type="primary">
												 Download PDF
												</Button>
												</a>	
												
												  <button class="remove" id='remove' onClick={this.removeServer.bind(this,get_url_name(file),'file',list.id)} type='button' title='Remove'><i class="ri-close-line icon-x"></i></button>									

											</div>
											</div>
											</div>
											</div>					


												
												</>))}
											</div>	
											)
											}
										})()}		

											
										{(() => {
											if (list.img.length>0) {
												return (	
											<div class="col m12  s12 no-padd  m-img">
												{list.img.map((img) => (<>
										<div class="dfs">
											<div class="ant-upload-list ant-upload-list-picture-card">
											<div class="ant-upload-list-item ant-upload-list-item-done">
											   <div class="ant-upload-list-item-info">					  
												<ModalImage  small={img} large={img} hideDownload="true" />
												
												  <button class="remove" id='remove' onClick={this.removeServer.bind(this,get_url_name(img),'image',list.id)} type='button' title='Remove'><i class="ri-close-line icon-x"></i></button>									

											</div>
											</div>
											</div>
											</div>					
												
												</>))}
											</div>
											)
												}
											})()}		

								



	
				     </>	)
					 }
					})()}			
											
													
											
											
											
											
												{this.state.file_list.map((img) => (
												<>
												{(() => {
												  return (
								
														<div class="ant-upload-list ant-upload-list-picture-card">
														<div class="ant-upload-list-item ant-upload-list-item-done">
														   <div class="ant-upload-list-item-info">
														  
																
																{/* <label>{img.file_name}</label>	*/}
															<ModalImage  small={img.file_url} large={img.file_url} hideDownload="true" />
															  <button class="remove" id='remove' data-file={img.file_name} onClick={this.removeFile.bind(this,img.file_name)} type='button' title='Remove'><CloseOutlined /></button>									

														</div>
														</div>
														</div>
												)						
												
												})()}
												</>
												))}
												</div>
												<div class="col-md-12">
												{this.state.file_list_pdf.map((img) => (
												<>
												{(() => {
												  return (
								
														<div class="ant-upload-list ant-upload-list-picture-card pdf">
														<div class="ant-upload-list-item ant-upload-list-item-done">
														   <div class="ant-upload-list-item-info">
														  
																
															<label>{img.file_name}</label>	
															
															  <button class="remove" id='remove' data-file={img.file_name} onClick={this.removeFilepdf.bind(this,img.file_name)} type='button' title='Remove'><CloseOutlined /></button>									

														</div>
														</div>
														</div>
												)						
												
												})()}
												</>
												))}
												</div>
												<div class="col-md-12">
												{this.state.file_list_audio.map((img) => (
												<>
												{(() => {
												  return (
								
														<div class="ant-upload-list ant-upload-list-picture-card pdf">
														<div class="ant-upload-list-item ant-upload-list-item-done">
														   <div class="ant-upload-list-item-info">
														  
																
															<label>{img.file_name}</label>	
															
															  <button class="remove" id='remove' data-file={img.file_name} onClick={this.removeFileaudio.bind(this,img.file_name)} type='button' title='Remove'><CloseOutlined /></button>									

														</div>
														</div>
														</div>
												)						
												
												})()}
												</>
												))}
												</div>
							</div>
						</div>
					
					
					<div class="meal mt-20 mb-20 center">
						 <Button className="ant-btn btn btn-secondry mr-2" onClick={this.goBack}>Back</Button>
														 <Button className="ant-btn btn  btn-primary mr-2" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
					</div>	
					</div>	
					
					
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			</> ))}
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
